import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Params} from '@angular/router';

@Component({
  selector: 'si-generic-dialog',
  templateUrl: './generic-dialog.component.html',
  styleUrls: ['./generic-dialog.component.scss']
})
export class GenericDialogComponent {
  @Input() displayDialog: boolean;
  @Input() dialogSizeClass = 'si-dialog-small';
  @Input() dialogStyleClass: string;
  @Input() closable = true;
  @Input() draggable = false;
  @Input() dialogTitle: string;
  @Input() dialogTitleStyleClass: string;
  @Input() dialogImg: string;
  @Input() dialogText: string;
  @Input() centerButtons = false;
  @Input() button1Text: string;
  @Input() button1Class: string;
  @Input() button1Href: string;
  @Input() button1Params: Params;
  @Input() button1Disabled: boolean;
  @Input() button1Close = true;
  @Input() button2Text: string;
  @Input() button2Class: string;
  @Input() button2Href: string;
  @Input() button2Params: Params;
  @Input() button2Disabled: boolean;
  @Input() button2Close = true;
  @Input() button3Text: string;
  @Input() button3Class: string;
  @Input() button3Href: string;
  @Input() button3Params: Params;
  @Input() button3Disabled: boolean;
  @Input() button3Close = true;
  @Input() isScrollable: boolean;
  @Output() displayDialogChange = new EventEmitter<boolean>();
  @Output() updateButton1Change = new EventEmitter<any>();
  @Output() updateButton2Change = new EventEmitter<any>();
  @Output() updateButton3Change = new EventEmitter<any>();

  onVisibleChange(value: boolean): void {
    this.displayDialogChange.emit(value);
  }

  onClickCloseDialog(): void {
    this.displayDialog = false;
    this.displayDialogChange.emit(this.displayDialog);
  }

  onClickButton1(): void {
    this.updateButton1Change.emit();
    if (this.button1Close) {
      this.onClickCloseDialog();
    }
  }

  onClickButton2(): void {
    this.updateButton2Change.emit();
    if (this.button2Close) {
      this.onClickCloseDialog();
    }
  }

  onClickButton3(): void {
    this.updateButton3Change.emit();
    if (this.button3Close) {
      this.onClickCloseDialog();
    }
  }
}
